import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckIcon, ZapIcon } from 'lucide-react';
const modelsData = [{
  id: 'lujo',
  tabName: 'Colección Lujo',
  title: 'Colección Lujo: La Experiencia Exclusiva',
  description: 'Diseño minimalista y elegante para propiedades de alto valor en Las Mercedes, Altamira y La Lagunita',
  image: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?auto=format&fit=crop&q=80&w=1000',
  features: ['Tours virtuales 360° integrados', 'Perfiles de agentes especializados', 'Narrativas de valor único'],
  demandOsBenefit: 'Sincronización en tiempo real de tours y perfiles de agentes',
  highlightColor: 'bg-remax-blue',
  textColor: 'text-remax-blue',
  borderColor: 'border-remax-blue'
}, {
  id: 'conversion',
  tabName: 'Tecnología de Conversión',
  title: 'Tecnología de Conversión: Eficiencia en Captación de Leads',
  description: 'Diseño minimalista y directo, optimizado para campañas de Meta ADS',
  image: 'https://images.unsplash.com/photo-1568605114967-8130f3a36994?auto=format&fit=crop&q=80&w=1000',
  features: ['Calculadora de valoración instantánea', 'Chatbot con IA para calificación inicial', 'Formularios cortos y optimizados'],
  demandOsBenefit: 'Los leads alimentan directamente el embudo de ventas de Demand OS',
  highlightColor: 'bg-remax-red',
  textColor: 'text-remax-red',
  borderColor: 'border-remax-red'
}, {
  id: 'comunidad',
  tabName: 'Comunidad & Estilo de Vida',
  title: 'Comunidad & Estilo de Vida: Conexión Local',
  description: 'Conexión emocional con las urbanizaciones de Caracas',
  image: 'https://images.unsplash.com/photo-1583337130417-3346a1be7dee?auto=format&fit=crop&q=80&w=1000',
  features: ['Mapas interactivos por zonas', 'Blog de estilo de vida local', 'Sección "Recientemente Vendido"'],
  demandOsBenefit: 'Segmentación de leads por zonas geográficas',
  highlightColor: 'bg-remax-blue',
  textColor: 'text-remax-blue',
  borderColor: 'border-remax-blue'
}, {
  id: 'agentes',
  tabName: 'Centrado en Agentes',
  title: 'Centrado en Agentes: Potencia tu Marca Personal',
  description: 'Plataforma para destacar a los asesores de REMAX Domus',
  image: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&q=80&w=1000',
  features: ['Perfiles personalizados de agentes', 'Calendario de citas integrado', 'Sistema de reseñas por agente'],
  demandOsBenefit: 'Agendamiento automático y notificaciones en tiempo real',
  highlightColor: 'bg-remax-red',
  textColor: 'text-remax-red',
  borderColor: 'border-remax-red'
}];
export const ModelsSection: React.FC = () => {
  const [activeTab, setActiveTab] = useState(modelsData[0].id);
  const activeModel = modelsData.find(m => m.id === activeTab) || modelsData[0];
  return <section id="modelos" className="py-20 bg-gray-50" data-id="element-109">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-110">
        <div className="text-center mb-12" data-id="element-111">
          <h2 className="text-3xl md:text-4xl font-bold text-remax-dark mb-4" data-id="element-112">
            Nuestros Modelos Web
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-113">
            Explora las cuatro arquitecturas diseñadas específicamente para
            maximizar tus resultados en el mercado inmobiliario de Caracas.
          </p>
        </div>

        {/* Tabs Navigation */}
        <div className="flex flex-wrap justify-center gap-2 mb-12" data-id="element-114">
          {modelsData.map(model => <button key={model.id} onClick={() => setActiveTab(model.id)} className={`px-6 py-3 rounded-full font-medium transition-all duration-300 ${activeTab === model.id ? `${model.highlightColor} text-white shadow-lg scale-105` : 'bg-white text-gray-600 hover:bg-gray-100 border border-gray-200'}`} data-id="element-115">
              {model.tabName}
            </button>)}
        </div>

        {/* Tab Content */}
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100" data-id="element-116">
          <AnimatePresence mode="wait" data-id="element-117">
            <motion.div key={activeTab} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -20
          }} transition={{
            duration: 0.4
          }} className="grid grid-cols-1 lg:grid-cols-2 gap-0" data-id="element-118">
              {/* Image Side (Mockup) */}
              <div className="p-8 lg:p-12 bg-gray-100 flex items-center justify-center" data-id="element-119">
                <motion.div whileHover={{
                scale: 1.02,
                y: -5
              }} transition={{
                type: 'spring',
                stiffness: 300
              }} className="relative w-full max-w-md aspect-[4/3] rounded-xl overflow-hidden shadow-2xl border-4 border-white bg-white" data-id="element-120">
                  {/* Browser Header Mockup */}
                  <div className="h-6 bg-gray-200 w-full flex items-center px-3 space-x-1.5" data-id="element-121">
                    <div className="w-2.5 h-2.5 rounded-full bg-red-400" data-id="element-122"></div>
                    <div className="w-2.5 h-2.5 rounded-full bg-yellow-400" data-id="element-123"></div>
                    <div className="w-2.5 h-2.5 rounded-full bg-green-400" data-id="element-124"></div>
                  </div>
                  <img src={activeModel.image} alt={activeModel.title} className="w-full h-[calc(100%-1.5rem)] object-cover" data-id="element-125" />
                </motion.div>
              </div>

              {/* Content Side */}
              <div className="p-8 lg:p-12 flex flex-col justify-center" data-id="element-126">
                <h3 className={`text-2xl md:text-3xl font-bold mb-4 ${activeModel.textColor}`} data-id="element-127">
                  {activeModel.title}
                </h3>
                <p className="text-gray-600 text-lg mb-8" data-id="element-128">
                  {activeModel.description}
                </p>

                <ul className="space-y-4 mb-8" data-id="element-129">
                  {activeModel.features.map((feature, idx) => <li key={idx} className="flex items-start" data-id="element-130">
                      <div className={`mt-1 mr-3 flex-shrink-0 rounded-full p-1 ${activeModel.highlightColor} bg-opacity-10`} data-id="element-131">
                        <CheckIcon className={`w-4 h-4 ${activeModel.textColor}`} data-id="element-132" />
                      </div>
                      <span className="text-gray-700 font-medium" data-id="element-133">
                        {feature}
                      </span>
                    </li>)}
                </ul>

                <div className={`mt-auto p-5 rounded-xl border-l-4 ${activeModel.borderColor} bg-gray-50`} data-id="element-134">
                  <div className="flex items-center mb-2" data-id="element-135">
                    <ZapIcon className={`w-5 h-5 mr-2 ${activeModel.textColor}`} data-id="element-136" />
                    <h4 className="font-bold text-remax-dark" data-id="element-137">
                      Beneficio Demand OS
                    </h4>
                  </div>
                  <p className="text-gray-700 text-sm md:text-base" data-id="element-138">
                    {activeModel.demandOsBenefit}
                  </p>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </section>;
};